export default "__VITE_PUBLIC_ASSET__a612fed0__"